<template>
    <div class="float-left mr-2">
        <span class="text-primary">
            <i
                class="fa fa-download fa-lg icon-button"
                title="Download"
                @click.stop="download()"
            ></i>
        </span>
    </div>
</template>

<script>
import FiscalizacoesServicos from '../FiscalizacoesServicos'

export default {
    props: {
        documento: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {        
        download() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.downloadAvaliacaoAnexo(this.documento).then(response => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao realizar download do arquivo!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, this.documento.nomeArquivo)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
